import {
  Dialog,
  DialogActions,
  DialogDescription,
  DialogTitle,
} from "../../atoms/dialog";
import { Button } from "../../atoms/button";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ModalProps {
  handleConfirm: () => void;
  handleOpen?: () => void;
  handleClose: () => void;
  title: string;
  description?: string | React.ReactNode;
  isOpen: boolean;
  loading?: boolean;
  buttonText?: string;
  red?: boolean;
  className?: string;
}
export default function Modal({
  handleConfirm,
  handleClose,
  isOpen,
  title,
  description,
  loading,
  buttonText = "Confirm",
  red = false,
  className,
}: ModalProps) {
  return (
    <Dialog
      className={className}
      centered
      size="md"
      open={isOpen}
      onClose={handleClose}>
      <div className="flex justify-start items-start space-x-4">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon
            aria-hidden="true"
            className="h-6 w-6 text-red-600"
          />
        </div>
        <div className="flex flex-col space-y-1">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </div>
      </div>
      <DialogActions>
        <Button outline onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color={red ? "red" : "blue"}
          loading={loading}
          disabled={loading}
          onClick={handleConfirm}>
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
